// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vhngazHtcgexciKb6F6c{flex-direction:column;display:flex}.dhWNek05QHSS34unjxno{margin-bottom:12px}.dhWNek05QHSS34unjxno:last-of-type{margin-bottom:0}.SWmPsH1SEpMam0X96NSW{color:var(--content-primary-primary-inverted);margin-bottom:3px;font-size:13px;font-weight:400}.reeG9yEa6XgpLT5ulQJL{color:var(--content-primary-tertiary-inverted,rgba(255,255,255,.7));align-items:center;font-size:11px;font-weight:400;display:flex}.reeG9yEa6XgpLT5ulQJL>span:first-of-type{margin-right:3px}.Rjmc3vAV9kQdx5O1Mkmr{cursor:pointer}.aVRJSyeAvgE2W4wPp7QR{color:var(--content-primary-tertiary-inverted,rgba(255,255,255,.7));background:var(--background-primary-inverted-disabled,rgba(255,255,255,.1));border-radius:4px;margin:8px 0 0;padding:6px 6px 5px;font-size:12px;font-weight:400;line-height:16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `vhngazHtcgexciKb6F6c`,
	"item": `dhWNek05QHSS34unjxno`,
	"item__title": `SWmPsH1SEpMam0X96NSW`,
	"itemTitle": `SWmPsH1SEpMam0X96NSW`,
	"item__desc": `reeG9yEa6XgpLT5ulQJL`,
	"itemDesc": `reeG9yEa6XgpLT5ulQJL`,
	"item_hasDropDown": `Rjmc3vAV9kQdx5O1Mkmr`,
	"itemHasDropDown": `Rjmc3vAV9kQdx5O1Mkmr`,
	"dropdown": `aVRJSyeAvgE2W4wPp7QR`
};
export default ___CSS_LOADER_EXPORT___;
